import PassbookNewFieldModalView from "./PassbookNewFieldModal.html";


angular.module('passbooks')
    .controller("PassbookEditCtrl", ['LoginService', '$scope', '$rootScope', '$state', '$stateParams', 'Restangular', 'gridService', '$filter', '$translate', 'modalService', '$uibModal', 'Upload', 'uiGridConstants',
        function (LoginService, $scope, $rootScope, $state, $stateParams, Restangular, gridService, $filter, $translate, modalService, $uibModal, Upload, uiGridConstants) {

            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = true // LoginService.permissionExist("passbookS_WRITE");
            $rootScope.title = $filter('translate')('passbooks.title');
            $scope.passbook = {
                primary_field: { type: "primary" },
                extra_fields: [],
                background_color: "#ffffff",
                barcode_text: "[GUEST_GUID]"
            };

            $scope.passbook_types = [
                { id: "QR", name: 'QR' },
                { id: "PDF417", name: 'PDF417' },
                { id: "Aztec", name: 'Aztec' },
                { id: "CODE128", name: 'CODE128' },
            ];
            
            $scope.showImg = "";

            $scope.configurePassbooksFields = function () {
                let i = 0;
                $scope.passbook.extra_fields.forEach(function (f) {
                    f.inGrid = true;
                })
                $scope.gridExtraFields.data = $scope.passbook.extra_fields;             
            }

            Restangular.all('Locations', { located_in_gps_only: true }).getList().then(results => $scope.selectLocations = results);

            if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {
                $rootScope.breadcrumb = [
                    { title: $filter('translate')('passbooks.title'), url: "passbooks.list" },
                    { title: $filter('translate')('passbooks.title_add') },
                ];
            } else {
                $rootScope.breadcrumb = [
                    { title: $filter('translate')('passbooks.title'), url: "passbooks.list" },
                    { title: $filter('translate')('passbooks.title_edit') },
                ];

                Restangular.one('Passbooks', $stateParams.id).get().then(function (result) {
                    $scope.passbook = result;
                    $scope.passbookType = $scope.passbook_types.filter(function (item) { return item.id === $scope.passbook.barcode_type })[0];
                    if($scope.passbook.expiration_date != null && $scope.passbook.expiration_date !== "" && $scope.passbook.expiration_date !== "null") {
                        $scope.passbook.expiration_date = new Date($scope.passbook.expiration_date);
                    }
                    if ($scope.passbook.start_date != null && $scope.passbook.start_date !== "" && $scope.passbook.start_date !== "null") {
                        $scope.passbook.start_date = new Date($scope.passbook.start_date);
                    }
                    $scope.configurePassbooksFields();
                });

 // Gestionamos las imagenes e Iconos 

                Restangular.all('Files').getList({ entity_type: 'passbooks', entity_type_id: $stateParams.id }).then(function (result) {
                    result ? $scope.strip_image = result[0] : "";
                    if ($scope.strip_image != null) {
                        Restangular.one(`Files/${$scope.strip_image.uid}/download/b64`).get().then(function (result) {
                            $scope.showImg = `data:image/jpeg;base64,${result}`;
                        })
                    }
                });
 // Gestionamos los iconos
                Restangular.all('Files').getList({ entity_type: 'passbooks_icon_1', entity_type_id: $stateParams.id }).then(function (result) {
                    result ? $scope.icon1 = result[0] : "";
                    if ($scope.icon1 != null) {
                        Restangular.one(`Files/${$scope.icon1.uid}/download/b64`).get().then(function (result) {
                            $scope.showicon1 = `data:image/jpeg;base64,${result}`;
                        })
                    }
                });

                Restangular.all('Files').getList({ entity_type: 'passbooks_icon_2', entity_type_id: $stateParams.id }).then(function (result) {
                    result ? $scope.icon2 = result[0] : "";
                    if ($scope.icon2 != null) {
                        Restangular.one(`Files/${$scope.icon2.uid}/download/b64`).get().then(function (result) {
                            $scope.showicon2 = `data:image/jpeg;base64,${result}`;
                        })
                    }
                });

                Restangular.all('Files').getList({ entity_type: 'passbooks_icon_3', entity_type_id: $stateParams.id }).then(function (result) {
                    result ? $scope.icon3 = result[0] : "";
                    if ($scope.icon3 != null) {
                        Restangular.one(`Files/${$scope.icon3.uid}/download/b64`).get().then(function (result) {
                            $scope.showicon3 = `data:image/jpeg;base64,${result}`;
                        })
                    }
                });
                Restangular.all('Files').getList({ entity_type: 'passbooks_icon_3', entity_type_id: $stateParams.id }).then(function (result) {
                    result ? $scope.icon3 = result[0] : "";
                    if ($scope.icon3 != null) {
                        Restangular.one(`Files/${$scope.icon3.uid}/download/b64`).get().then(function (result) {
                            $scope.showicon3 = `data:image/jpeg;base64,${result}`;
                        })
                    }
                });

// Gestionamos el logo

                Restangular.all('Files').getList({ entity_type: 'passbooks_logo', entity_type_id: $stateParams.id }).then(function (result) {
                    result ? $scope.logo = result[0] : "";
                    if ($scope.logo != null) {
                        Restangular.one(`Files/${$scope.logo.uid}/download/b64`).get().then(function (result) {
                            $scope.showLogo = `data:image/jpeg;base64,${result}`;
                        })
                    }
                });

            }

            $scope.selectImage = function () {
                $("#frmImage").trigger("click");
                $("#frmImage").change(function () {
                    const imageElement = document.querySelector('#frmImage') as HTMLInputElement;
                    const file = imageElement?.files?.[0];
                    if (file) {
                        const fileReader = new FileReader();
                        fileReader.onload = function (event) {
                            const src = (event.target as FileReader).result;
                            $scope.showImg = src;
                            if (!$scope.$$phase) $scope.$apply();
                        };
                        fileReader.readAsDataURL(file);
                        $scope.file = file;
                    } 
                });
            };

            $scope.selecticon = function (num) {
                $("#frmicon" + num).trigger("click");
                $("#frmicon" + num).change(function () {
                    const iconElement = document.querySelector('#frmicon' + num) as HTMLInputElement;
                    const file = iconElement?.files?.[0];
                    if (file) {
                        const fileReader = new FileReader();
                        fileReader.onload = function (event) {
                            const src = (event.target as FileReader).result;
                            switch (num) {
                                case 1:
                                   $scope.showicon1 = src;
                                    break;
                                case 2:
                                    $scope.showicon2 = src;
                                    break;
                                case 3:
                                    $scope.showicon3 = src;
                                    break;
                            }
                            if (!$scope.$$phase) $scope.$apply();
                        };
                        fileReader.readAsDataURL(file);
                        switch (num) {
                            case 1:
                            $scope.file_icon1 = file;
                                break;
                            case 2:
                                $scope.file_icon2 = file;
                                break;
                            case 3:
                                $scope.file_icon3 = file;
                                break;
                        }
                    }
                });
            };


            $scope.selectLogo = function () {
                $("#frmLogo").trigger("click");
                $("#frmLogo").change(function () {
                    const logoElement = document.querySelector('#frmLogo') as HTMLInputElement;
                    const file = logoElement?.files?.[0];
                    if (file) {
                        const fileReader = new FileReader();
                        fileReader.onload = function (event) {
                            const src = (event.target as FileReader).result;
                            $scope.showLogo = src;
                            if (!$scope.$$phase) $scope.$apply();
                        };
                        fileReader.readAsDataURL(file);
                        $scope.file_logo = file;
                    }
                });
            };

            $scope.getImage = function () {
                if ($scope.showImg && $scope.showImg != "") {
                    return $scope.showImg;
                } else {
                    return "assets/img/no-image.png";
                }
            };

            $scope.geticon = function (num) {
                switch (num) {
                    case 1:
                        if ($scope.showicon1 && $scope.showicon1 != "") {
                            return $scope.showicon1;
                        } else {
                            return "assets/img/no-image.png";
                        }
                        break;
                    case 2:
                        if ($scope.showicon2 && $scope.showicon2 != "") {
                            return $scope.showicon2;
                        } else {
                            return "assets/img/no-image.png";
                        }
                        break;
                    case 3:
                        if ($scope.showicon3 && $scope.showicon3 != "") {
                            return $scope.showicon3;
                        } else {
                            return "assets/img/no-image.png";
                        }
                        break;
                }
            };


            $scope.getLogo = function () {
                if ($scope.showLogo && $scope.showLogo != "") {
                    return $scope.showLogo;
                } else {
                    return "assets/img/no-image.png";
                }
            };


            $scope.removeImage = function ( $event) {
                event.stopPropagation();
                $scope.showImg = null;
                $scope.file = null;
                if (typeof ($event) !== "undefined") {
                    $event.preventDefault();
                    $event.stopPropagation();
                }
            };

            $scope.removeicon = function (num, $event) {
                event.stopPropagation();
                switch (num) {
                    case 1:
                        $scope.showicon1 = null;
                        $scope.file_icon1 = null;
                        break;
                    case 2:
                        $scope.showicon2 = null;
                        $scope.file_icon2 = null;
                        break;
                    case 3:
                        $scope.showicon3 = null;
                        $scope.file_icon3 = null;
                        break;
                }
                if (typeof ($event) !== "undefined") {
                    $event.preventDefault();
                    $event.stopPropagation();
                }
            };


            $scope.removeLogo = function ($event) {
                event.stopPropagation();
                $scope.showLogo = null;
                $scope.file_logo = null;
                if (typeof ($event) !== "undefined") {
                    $event.preventDefault();
                    $event.stopPropagation();
                }
            };

            let uploadFile = function (id) {
                $scope.file.upload = Upload.upload({
                    url: (window as any).CONFIG.api_url + "Files/uploadFile",
                    data: { file: $scope.file, id: 0, entity_type: "passbooks", entity_type_id: id, is_public: "true"},
                });

                $scope.file.upload.then(function (response) {
                }, function (response) {
                    if (response.status > 0) {
                        let errorMsg = response.status + ': ' + response.data;
                        toastr.error("Ha ocurrido un error: " + errorMsg);
                    }
                });
            }

            let uploadicons = function (id, num) {
                switch (num) {
                    case 1:
                        $scope.file_icon1.upload = Upload.upload({
                            url: (window as any).CONFIG.api_url + "Files/uploadFile",
                            data: { file: $scope.file_icon1, id: 0, entity_type: "passbooks_icon_1", entity_type_id: id, is_public: "true" },
                        });

                        $scope.file_icon1.upload.then(function (response) {
                        }, function (response) {
                            if (response.status > 0) {
                                let errorMsg = response.status + ': ' + response.data;
                                toastr.error("Ha ocurrido un error: " + errorMsg);
                            }
                        });
                        break;
                    case 2:
                        $scope.file_icon2.upload = Upload.upload({
                            url: (window as any).CONFIG.api_url + "Files/uploadFile",
                            data: { file: $scope.file_icon2, id: 0, entity_type: "passbooks_icon_2", entity_type_id: id, is_public: "true" },
                        });

                        $scope.file_icon2.upload.then(function (response) {
                        }, function (response) {
                            if (response.status > 0) {
                                let errorMsg = response.status + ': ' + response.data;
                                toastr.error("Ha ocurrido un error: " + errorMsg);
                            }
                        });
                        break;
                    case 3:
                        $scope.file_icon3.upload = Upload.upload({
                            url: (window as any).CONFIG.api_url + "Files/uploadFile",
                            data: { file: $scope.file_icon3, id: 0, entity_type: "passbooks_icon_3", entity_type_id: id, is_public: "true" },
                        });

                        $scope.file_icon3.upload.then(function (response) {
                        }, function (response) {
                            if (response.status > 0) {
                                let errorMsg = response.status + ': ' + response.data;
                                toastr.error("Ha ocurrido un error: " + errorMsg);
                            }
                        });
                        break;
                }
            };


            let uploadLogo = function (id) {
                $scope.file_logo.upload = Upload.upload({
                    url: (window as any).CONFIG.api_url + "Files/uploadFile",
                    data: { file: $scope.file_logo, id: 0, entity_type: "passbooks_logo", entity_type_id: id, is_public: "true" },
                });

                $scope.file_logo.upload.then(function (response) {
                }, function (response) {
                    if (response.status > 0) {
                        let errorMsg = response.status + ': ' + response.data;
                        toastr.error("Ha ocurrido un error: " + errorMsg);
                    }
                });
            }

            let manageFile = function (id) {
                if ($scope.file) { uploadFile(id) };
                if ($scope.strip_image && ($scope.file || !$scope.showImg)) { $scope.strip_image.remove() }
            }

            let manageicons = function (id) {
                if ($scope.file_icon1) { uploadicons(id,1) };
                if ($scope.icon1 && ($scope.file_icon1 || !$scope.showicon1)) { $scope.icon1.remove() }
                if ($scope.file_icon2) { uploadicons(id,2) };
                if ($scope.icon2 && ($scope.file_icon2 || !$scope.showicon2)) { $scope.icon2.remove() }
                if ($scope.file_icon3) { uploadicons(id, 3) };
                if ($scope.icon3 && ($scope.file_icon3 || !$scope.showicon3)) { $scope.icon3.remove() }
            };


            let manageLogo = function (id) {
                if ($scope.file_logo) { uploadLogo(id) };
                if ($scope.logo && ($scope.file_logo || !$scope.showLogo)) { $scope.logo.remove() }
            }


 // Gestión de campos 
            $scope.addField = function (field) {

                field ? $scope.newField = field : $scope.newField = {};

                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: PassbookNewFieldModalView,
                    controller: "PassbookNewFieldModalCtrl",
                    resolve: {},
                    scope: $scope,
                    size: 'lg'
                });
            };
     
            $scope.removeField = function (field) {
                let index = $scope.passbook.extra_fields.indexOf(field)
                $scope.passbook.extra_fields.splice(index, 1);
            };

            // Campos adicionales 
            $scope.gridExtraFields = {
                pdfTitle: $filter('translate')('passbooks.extra_fields'),
                enableGridMenu: false,
                gridMenuShowHideColumns: false,
                enableSorting: true,
                enablePaginationControls: false,
                paginationPageSizes: [5, 10, 15],
                paginationPageSize: 5,
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                },
                columnDefs: [
                    { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                    { name: 'field_order', displayName: $filter('translate')('passbooks.field_order'), enableSorting: true, enableHiding: false, visible: true, enableCellEdit: true, type:'number', width: 200 },
                    { name: 'type', displayName: $filter('translate')('passbooks.type'), enableFiltering: false,   enableHiding: false, visible: true, enableCellEdit: true, width: 150 },
                    { name: 'label', displayName: $filter('translate')('passbooks.label'), enableFiltering: false,  enableHiding: false, visible: true, enableCellEdit: true, width: 150 },
                    { name: 'value', displayName: $filter('translate')('passbooks.value'), enableFiltering: false,  enableHiding: false, visible: true, enableCellEdit: true },
                    {
                        name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, enableCellEdit: false, cellTemplate: gridService.actionTemplate([
                            { title: $filter('translate')('general.button_edit'), action: 'ng-click="grid.appScope.addField(row.entity);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-edit" },
                            { title: $filter('translate')('general.button_delete'), action: 'ng-click="grid.appScope.removeField(row.entity);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                        ], { cssClass: "pull-right" })
                    },
                ],
            };
            
            $scope.testPassbook = function () {
                window.open((window as any).CONFIG.api_url + "Passbooks/test/" + $scope.passbook.id, '_blank');
            };

            $scope.savePassbook = function () {
                $scope.passbook.primary_field.type = 'primary';
                $scope.passbook.barcode_type = $scope.passbookType.id;
                if (angular.isDefined($scope.passbook.id)) {
                    $scope.passbook.put().then(function (result) {
                        if (angular.isDefined(result.id)) {
                            manageFile(result.id);
                            manageicons(result.id);
                            manageLogo(result.id);
                            toastr.success($filter('translate')('passbooks.edit_success'));
                            $state.go("passbooks.list");
                        } else {
                            $scope.errorMessage = result.message;
                        }
                    });
                } else {
                    Restangular.all('Passbooks').post($scope.passbook).then(function (result) {
                        if (angular.isDefined(result.id)) {
                            manageFile(result.id);
                            manageicons(result.id);
                            manageLogo(result.id);
                            toastr.success($filter('translate')('passbooks.save_success'));
                            $state.go("passbooks.list");
                        } else {
                            $scope.errorMessage = result.message;
                        }
                    });
                } 
            }

            $scope.checkDelete = function () {
                modalService.confirm({
                    title: $filter('translate')('passbooks.delete_message'),
                    message: $filter('translate')('passbooks.delete_message') + " " + $scope.passbook.name + "?",
                    onAccept: function () {
                        if ($scope.strip_image) { $scope.strip_image.remove() };
                        $scope.passbook.remove().then(function () {
                            toastr.success($filter('translate')('passbooks.deleted_success'));
                            $state.go("passbooks.list");
                        });
                    }
                });
            };
        }])

    .controller("PassbookNewFieldModalCtrl", ['$scope', '$uibModalInstance', 'modalService', '$filter',  function ($scope, $uibModalInstance, modalService, $filter) {

        $scope.modalSelect = [{ name: 'header' }, { name: 'secondary' }, { name: 'auxiliary' }, { name: 'back' }];

        $scope.newFieldTitle = $scope.newField.id ? ($filter('translate')('passbooks.field_edit')) : ($filter('translate')('passbooks.field_add'));
        let defaultPosition;
        // Sugerimos una posición por defecto
        let orderList = $scope.passbook.extra_fields.map(f => f.field_order);

        if (orderList.length > 0) {
            defaultPosition = Math.max(...orderList) + 1;
        }
        if (!defaultPosition) {
            defaultPosition = 1;
        };

        $scope.newField.field_order = $scope.newField.field_order ?? defaultPosition;

        $scope.onCancel = function () {
            $scope.newField = {};
            $uibModalInstance.dismiss('cancel');
        };

        $scope.onAccept = function () {
            if (!$scope.newField.inGrid) {
                $scope.passbook.extra_fields.push($scope.newField);
            };
            $scope.configurePassbooksFields();
            $scope.newField = {};
            $uibModalInstance.close();
        };

    }]);